module.exports = __webpack_public_path__ + "@/assets/img/file.fab29ff6.svg";